import { apiClient } from './api-client';
import type { TenantSettings, UpdateTenantSettingsInput } from '../types/tenant-settings';

export async function fetchTenantSettings(): Promise<TenantSettings> {
  return apiClient<TenantSettings>('/admin/tenant/settings');
}

export async function updateTenantSettings(
  input: UpdateTenantSettingsInput
): Promise<TenantSettings> {
  return apiClient<TenantSettings>('/admin/tenant/settings', {
    method: 'PUT',
    body: JSON.stringify(input),
  });
}
